module.exports = __webpack_public_path__ + "img/small-18.328ab1eb.jpg";